module.exports = __webpack_public_path__ + "media/slot-game/semmel-6158bdc9.svg";